module.exports = __webpack_public_path__ + "static/media/brandLogoTr.bb648107.png";